define('utils/form-validator',["jquery"], function ($) {
  return (function () {
    var errorMessageTemplate =
        '<span class="field-validation--error"><span class="icon icon-input_cross"></span><span class="field-validation__message">{error-msg}</span>',
      validMessageTemplate =
        '<span class="field-validation--valid"><span class="icon icon-check"></span></span>'; //Not sure if needed

    function FormValidator(form) {
      this.form = form;
      this.isShowValidMsg = false;
      this.formErrorPlaceholer = this.form.find(".form-error-placeholder");
      this.formErrorMessage = this.form.data("error-msg");

      this.initFieldsToValidate();

      this.initInputErrorMessages();
      this.updateFormErrorMessage();
    }

    FormValidator.prototype.initFieldsToValidate = function () {
      this.inputs = this.findFields();
    };

    FormValidator.prototype.findFields = function () {
      // TODO add validation of checkboxes, radiobtns if needed
      /*jshint multistr: true */
      return this.form.find(
        "\
        input[type=text],\
        input[type=password],\
        input[type=email],\
        input[type=tel],\
        input[type=number],\
        input[type=checkbox],\
        input[type=file],\
        select,\
        textarea"
      );
    };

    FormValidator.prototype.enableValidMsg = function () {
      this.isShowValidMsg = true;
    };

    FormValidator.prototype.initInputErrorMessages = function () {
      var _this = this;
      this.inputs.each(function () {
        var inputItem = $(this);

        if (inputItem.hasClass("input-validation-error")) {
          _this.setInputErrorMsg(inputItem);
        }
      });
    };

    FormValidator.prototype.updateFormErrorMessage = function () {
      if (this.inputs.filter(".input-validation-error").length) {
        this.setFormErrorMsg();
      } else {
        this.removeFormErrorMsg();
      }
    };

    FormValidator.prototype.validateForm = function () {
      var _this = this,
        isValidForm = true;

      // refresh set of fields to validate
      var fields = this.findFields()
        .filter(":not([disabled])")
        .filter(":not([readonly])");

      fields.each(function () {
        isValidForm = _this.validateInput($(this), true) && isValidForm;
      });

      return isValidForm;
    };

    FormValidator.prototype.setInputErrorMsg = function (el) {
      this.removeInputValidMsg(el);

      if (el.data("error-msg")) {
        if (!el.next(".field-validation--error").length) {
          el.after(
            errorMessageTemplate.replace("{error-msg}", el.data("error-msg"))
          );
        }
      }
      el.addClass("input-validation-error");

      if (el.is("select")) {
        el.parent().addClass("input-validation-error");
      }
    };

    FormValidator.prototype.removeInputErrorMsg = function (el) {
      if (el.next(".field-validation--error").length) {
        el.next(".field-validation--error").remove();
      }

      el.removeClass("input-validation-error");

      if (el.is("select")) {
        el.parent().removeClass("input-validation-error");
      }
    };

    FormValidator.prototype.setInputValidMsg = function (el) {
      this.removeInputErrorMsg(el);
      if (this.isShowValidMsg && !el.next(".field-validation--valid").length) {
        el.after(validMessageTemplate);
      }
    };

    FormValidator.prototype.removeInputValidMsg = function (el) {
      if (this.isShowValidMsg) {
        el.next(".field-validation--valid").remove();
      }
    };

    FormValidator.prototype.removeInputErrorMsgOn = function (eventName) {
      var _this = this;

      this.inputs.on(eventName, function (e) {
        _this.removeInputErrorMsg($(this));
      });
    };

    FormValidator.prototype.validateInputOn = function (eventName) {
      var _this = this;

      this.inputs.on(eventName, function (e) {
        _this.validateInput($(this), true);
      });

      this.inputs.filter("[data-validate-equal-id]").each(function () {
        var el = $(this),
          followEl = $("#" + el.data("validate-equal-id"));

        followEl.on(eventName, function () {
          _this.validateInput(el, true, el.val().length < 1);
        });
      });

      this.inputs.filter("[data-validate-require-id]").each(function () {
        var el = $(this),
          followEl = $("#" + el.data("validate-require-id"));

        el.on(eventName, function () {
          _this.validateInput(followEl, true);
        });
      });

      this.inputs.filter("[data-validate-currency]").each(function () {
        var el = $(this),
          followEl = $("#" + el.data("data-validate-currency"));

        el.on(eventName, function () {
          _this.validateInput(followEl, true);
        });
      });
    };

    FormValidator.prototype.setFormErrorMsg = function () {
      if (this.formErrorMessage && this.formErrorPlaceholer.length) {
        var errorMsg = $(
          errorMessageTemplate.replace("{error-msg}", this.formErrorMessage)
        );
        errorMsg.find(".icon").remove();
        this.formErrorPlaceholer.html(errorMsg);
      }
    };

    FormValidator.prototype.removeFormErrorMsg = function () {
      this.formErrorPlaceholer.html("");
    };

    FormValidator.prototype.resetAllErrorMsg = function () {
      var _this = this;
      this.inputs.each(function () {
        _this.removeInputErrorMsg($(this));
      });
      this.removeFormErrorMsg();
    };

    FormValidator.prototype.validateInput = function (
      el,
      isShowErrorMsgs,
      skipIfLengthZero
    ) {
      var isValid = this.isValidInput(el);

      if (isShowErrorMsgs) {
        if (!skipIfLengthZero) {
          if (!isValid) {
            this.removeInputValidMsg(el);
            this.setInputErrorMsg(el);
          } else {
            this.removeInputErrorMsg(el);
            this.setInputValidMsg(el);
          }
        }

        this.updateFormErrorMessage();
      }

      return isValid;
    };

    FormValidator.prototype.isValidInput = function (el) {
      var _this = this,
        isValidItem = true,
        type = el.prop("type"),
        required = !!el.prop("required");

      // check if this el is required for any other element that is not empty
      // e.x. old password to set a new one
      this.inputs
        .filter('[data-validate-require-id="' + el.prop("id") + '"]')
        .each(function () {
          if (_this.getValue($(this), true) == "") {
            required = true;
          }
        });

      this.inputs
        .filter('[data-validate-currency="' + el.prop("id") + '"]')
        .each(function () {
          isValidItem = _this.isValidCurrency(el);
        });

      switch (type) {
        case "email":
          isValidItem = this.isValidEmail(el) && isValidItem;
          break;
        case "password":
          if (el.data("validate-equal-id")) {
            var passwordEl = $("#" + el.data("validate-equal-id"));
            return this.isValidEqual(el, passwordEl) && isValidItem;
          } else {
            isValidItem = this.isValidPassword(el) && isValidItem;
          }
          break;
        case "checkbox":
          isValidItem = (!required || el.prop("checked")) && isValidItem;
          break;
      }

      if (required) {
        isValidItem = this.isValidRequired(el) && isValidItem;
      } else if (this.getValue(el).length === 0) {
        isValidItem = true;
      }

      return isValidItem;
    };

    FormValidator.prototype.isValidEmail = function (el) {
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(this.getValue(el, true));
    };

    FormValidator.prototype.isValidPassword = function (el) {
      return true;
    };

    FormValidator.prototype.isValidRequired = function (el, isTrim) {
      return !!this.getValue(el, isTrim).length;
    };

    FormValidator.prototype.isValidEqual = function (el1, el2) {
      return this.getValue(el1, false) === this.getValue(el2, false);
    };

    FormValidator.prototype.isValidNumber = function (el) {
      var re = /^[0-9]$/;
      return re.test(this.getValue(el, true));
    };

    FormValidator.prototype.isValidCurrency = function (el) {
      var re = /^(\d{0,4}(?:[\.\,]\d{0,2})?|)$/;
      return re.test(this.getValue(el, true));
    };

    FormValidator.prototype.getValue = function (el, isTrim) {
      var value = "";
      if (el instanceof jQuery) {
        value = el.val();
      } else if (typeof el === "string") {
        value = el;
      }

      if (isTrim) {
        value = $.trim(value);
      }

      return value;
    };

    return FormValidator;
  })();
});

